export const URL_ACCESS = process.env.NEXT_PUBLIC_ACCESS_URL ?? "";
